module.exports = __webpack_public_path__ + "static/media/data.3a408529.svg";